import VueGtm from '@gtm-support/vue2-gtm';

export default async ({ Vue, router }) => {
  Vue.use(VueGtm, {
    id: 'GTM-P6VRPG6J',
    defer: false,
    compatibility: false,
    debug: false,
    vueRouter: router,
    trackOnNextTick: false,
  });
};
